import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LocalStorageKeys } from "src/app/shared/models/local-storage.model";
import { AdvanceService } from "src/app/shared/services/advance.service";
import { map, filter, concatMap, tap } from "rxjs/operators";
import { AdvanceTypes, Advance } from "src/app/shared/models/advance.model";
import { TableDataSource } from "src/app/shared/components/table/table-data-source";
import { UserService } from "src/app/shared/services/user.service";
import { MatSort } from "@angular/material/sort";
import { tableSortFn } from "src/app/shared/utils/sort.util";
import { ToastrService } from "ngx-toastr";
import { FileSaverService } from "ngx-filesaver";
import { Redirect } from "../../shared/utils/redirect.util";
import { ConfirmService } from "../../shared/services/confirm.service";

@Component({
  selector: "app-advances",
  templateUrl: "./advances.component.html",
})
export class AdvancesComponent implements OnInit {
  title = "Twoje zaliczki";
  employeeId: number;
  userId: number;
  advanceUserId: number;
  advances$;
  employee;
  displayAdvaceByType = Object.values(AdvanceTypes);

  dataSource = new TableDataSource<Advance>();
  displayColumns: string[] = [
    "name",
    "status.name",
    "value",
    "unsettledValue",
    "leftValue",
    "createdAt",
    "updatedAt",
    "action",
  ];

  @ViewChild(MatSort, { static: false }) set sort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  constructor(
    private activeRoute: ActivatedRoute,
    private _advanceService: AdvanceService,
    private userService: UserService,
    private toastrService: ToastrService,
    private router: Router,
    private fs: FileSaverService,
    private redirect: Redirect,
    private confirmService: ConfirmService
  ) {}

  ngOnInit() {
    const advanceTypeParam =
      this.activeRoute.snapshot.paramMap.get("advanceType");
    if (advanceTypeParam) {
      this.displayAdvaceByType = this.displayAdvaceByType.filter(
        (advanceType) => advanceType === advanceTypeParam
      );
    }

    this.employeeId = parseInt(
      this.activeRoute.snapshot.paramMap.get("id"),
      10
    );
    this.userId = this.userService.getCurrentUserId();

    if (!isNaN(this.employeeId)) {
      this.advanceUserId = this.employeeId;
    } else {
      this.advanceUserId = this.userId;
    }
    this.advances$ = this._advanceService
      .fetchEmployeeAdvances(this.advanceUserId)
      .pipe(
        map((advances: Advance[]) => {
          this.dataSource.data = advances;
          this.dataSource.sortingDataAccessor = tableSortFn;
          return advances;
        }),
        map((advances: Advance[]) => ({
          static: advances.find(
            (v) =>
              v.type.name === AdvanceTypes.Static &&
              this.displayAdvaceByType.includes(AdvanceTypes.Static)
          ),
          additional: advances.filter(
            (v) =>
              v.type.name === AdvanceTypes.Additional &&
              this.displayAdvaceByType.includes(AdvanceTypes.Additional)
          ),
        })),
        tap((v: any) => {
          if (this.employeeId === this.advanceUserId) {
            if (v.static) {
              this.title =
                v.static.employee.person.firstName +
                " " +
                v.static.employee.person.lastName;
            } else if (v.additional) {
              const [advance] = v.additional;
              this.title =
                advance.employee.person.firstName +
                " " +
                advance.employee.person.lastName;
            }
          }
        })
      );
  }

  export(advanceId: number) {
    const filename = Date.now() + ".csv";
    this.toastrService.success(
      "Za moment uruchomi się pobieranie pliku przelewu."
    );
    this._advanceService.exportAdvance(advanceId).subscribe(
      (_) => {
        this._advanceService.exportToCsv(advanceId).subscribe(
          (result) => {
            this.fs.save(result, filename);
          },
          (_) =>
            this.toastrService.error(
              "Wystąpił problem z wygenerowaniem pliku przelewu."
            )
        );
        this.redirect.to();
      },
      (_) =>
        this.toastrService.error(
          "Zaliczki nie można wyeksportować, ponieważ może zawierać jeszcze nierozliczone koszty."
        )
    );
  }

  cancel(advance: Advance) {
    if (advance.canCancel) {
      this.confirmService
        .openConfirmDialog(
          "Czy na pewno chcesz anulować zaliczkę? Zmiana będzie nieodwracalna."
        )
        .afterClosed()
        .subscribe((confirm) => {
          if (confirm) {
            this._advanceService.cancelAdvance(advance.id).subscribe(
              (res) => {
                this.toastrService.success("Zaliczka została anulowana.");
                this.redirect.to();
              },
              (_) =>
                this.toastrService.error("Zaliczka nie może zostać anulowana.")
            );
          }
        });
    }
  }

  // TODO: Change redirect to response!
  redirectTo(uri: string) {
    this.router
      .navigateByUrl("/advances", { skipLocationChange: true })
      .then(() => this.router.navigate([uri]));
  }
}
